import { Component, OnInit, ViewChild } from '@angular/core';
import { Template } from 'src/app/models/template';
import { TemplateService } from 'src/app/services/template.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { findInRoute } from 'src/app/shared/utilities';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {

  //for embedded displaying of pdfs
  @ViewChild('pdfViewer') public pdfViewer;
  pdfBlob: Blob;
  template: Template;
  loading: boolean = true;

  headingText: string = "";

  previousTemplates: Template[];

  constructor(private templatesService: TemplateService,
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastrService) { }

  async ngOnInit(): Promise<void> {
    this.loading = true;

    let docId = findInRoute('idTemplate', this.route);

    this.template = await this.templatesService.getOne(+docId, ['compagnia', 'tipo_template']);

    try {
      this.pdfBlob = await this.templatesService.open(this.template, true).toPromise();
    }
    catch (e) {
      console.error(e);
      this.toast.error("Impossibile caricare il pdf")
    }

    this.loading = false;

    this.headingText = this.getHeading();
  }

  private getHeading(): string {

    let heading = `Template "${this.template.nome}"`;

    if (this.template.compagnia_id)
      heading += `, della compagnia ${this.template.compagnia.nome}`;

    if (this.template.tipo_template)
      heading += ` (${this.template.tipo_template.nome})`;

    return heading;

  }

  download(template: Template) {
    let url = template.url;
    let ext = url.substring(
      url.lastIndexOf('.') + 1
    );
    this.templatesService.open(template).subscribe((blob) =>
      saveAs(blob, `${template.nome}.${ext}`, { autoBom: true })
    );
  }


  async retryPdfConversion() {
    try {
      await this.templatesService.convertToPdf(this.template);
      await this.ngOnInit();
    }
    catch (e) {
      console.error(e);
      this.toast.error("Conversione in PDF fallita", "Errore!");
    }
  }

  navigateTo(template: Template) {
    this.router.navigate(['../', template.id], { relativeTo: this.route }).then(
      () => this.ngOnInit()
    );
  }
}
